export default {
  namespaced: false,
  state: {
    config: null,
    disableTracking: false,
  },
  getters: {},
  actions: {
    //config is actually the uiConfig
    async initTracking({state,commit,dispatch},config){
        let user = config.user;
        let instance = config.instance;
        let account = null;
        let visitor = null;
        if (config.disable_tracking){
          console.log("pendo tracking disabled")
          visitor = {
            id: null
          };
          account = {
            id: null
          };
        } else {
          console.log("pendo tracking enabled")
          visitor = {
            id: `${instance}_${config.user_email}`,
            email: config.user_email,
            first_name: user.first_name,
            last_name: user.last_name,
            // You can add any additional visitor level key-values here,
            // as long as it's not one of the above reserved names.
            role: user.role_name, //for radiate, pass roles: [list of role names]
            privs: user.privs,
          };
          account = {
            id: `${instance}_${config.account.id}`,
            name: config.account.account_name,
            created_dt: config.account.created_dt,
            //is_paying: false,
            //planLevel: "Sandbox"
            // monthly_value:// Recommended if using Pendo Feedback
            // planPrice:    // Optional
            // creationDate: // Optional

            // You can add any additional account level key-values here,
            // as long as it's not one of the above reserved names.
            sub_accounts: Array.isArray(config.sub_accounts) ? config.sub_accounts.map(itm=>{
              return {
                display_name: itm.sub_account_display_name, 
                storage_months: itm.storage_months, 
                channels: itm.channels
              }
            }) : []
          };
        }
        pendo.initialize({
          visitor: visitor,
          account: account
        });
        commit("setTrackingUiConfig",config)
    

    },
    async track({state,commit,dispatch},{name,props}){
      if (!state.disableTracking){
        console.log("track ",name, " ", props)
        pendo.track(name,props);
      }
    }
  },
  mutations: {
    setTrackingUiConfig(state,config){
      state.config = config;
      state.disableTracking = config.disable_tracking;
    },
  },  
}